module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26 20c-.25 0-.486.042-.726.074l-4.958-9.918A5.97 5.97 0 0 0 22 6a6 6 0 0 0-12 0c0 1.618.646 3.078 1.686 4.156l-4.958 9.918C6.486 20.042 6.25 20 6 20a6 6 0 0 0 0 12 6 6 0 0 0 6-6 5.964 5.964 0 0 0-1.686-4.156l4.958-9.918c.242.032.478.074.728.074s.486-.042.726-.074l4.958 9.918A5.97 5.97 0 0 0 20 26a6 6 0 0 0 12 0 6 6 0 0 0-6-6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/share-4.js
// module id = 1408
// module chunks = 14